export const cardData = [
    {
      "badge": "Emprestimos",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/financiamento",
      "title": "Financiamento",
      "description": "O financiamento possui baixas taxas de juros, mas a instituição financeira precisa de uma comprovação da finalidade do crédito solicitado."
    },
    {"badge": "Consumo",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/gatilhos-de-consumo",
      "title": "Gatilhos de consumo",
      "description": "Os gatilhos de consumo funcionam como mecanismos cerebrais, que levam as pessoas a adquirir produtos e serviços sem que tenham necessidade."
    },
    {
      "badge": "Consumo",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/consumo-consciente",
      "title": "Consumo Consciente",
      "description": "O consumo consciente é aquele que não envolve a exploração de seres humanos e tem por objetivo minimizar os impactos ao meio ambiente."
    },
    {
      "badge": "Juros & Impostos",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/taxa-de-juros",
      "title": "Taxa de Juros",
      "description": "A taxa de juros funciona como uma compensação, ou seja, o valor é calculado em cima do tempo que você ficou com dinheiro emprestado."
    },
    {
      "badge": "Consumo",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/procon",
      "title": "PROCON",
      "description": "O PROCON atua no âmbito estadual, por isso ele pode receber várias nomenclaturas a depender do estado e também ter diferentes estruturas."
    },
    {
      "badge": "Juros & Impostos",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/imposto-de-renda",
      "title": "Imposto de Renda",
      "description": "O Imposto de Renda gera tributos que são investidos em programas de incentivo à saúde, educação, inclusão social e criação de empregos."
    },
    {
      "badge": "Juros & Impostos",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/hipoteca",
      "title": "Hipoteca",
      "description": "No Brasil, a hipoteca foi substituída pelo empréstimo com garantia de imóvel. Este recurso possibilita juros mais baixos aos clientes."
    },
    {
      "badge": "Emprestimos",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/emprestimo",
      "title": "Empréstimo",
      "description": "Empréstimo: acordo financeiro realizado entre o cliente e uma instituição financeira. Além de juros e impostos, há prazos para pagamento."
    },
    {
      "badge": "Emprestimos",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/emprestimos-consignados",
      "title": "Empréstimos Consignados",
      "description": "Os empréstimos consignados referem-se às quantias de dinheiro liberadas para determinados grupos, como aposentados e servidores públicos."
    },
    {
      "badge": "Economizando",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/comportamento-poupador",
      "title": "Comportamento poupador",
      "description": "Como identificar se você tem um comportamento poupador? As características de quem poupa demais vai além da capacidade de guardar dinheiro."
    },
    {
      "badge": "Banco",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/conta-poupanca",
      "title": "Conta Poupança",
      "description": "A conta poupança é um tipo de conta bancária destinada às pessoas que querem guardar dinheiro e também obter uma receita extra a cada mês."
    },
    {
      "badge": "Consumo",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/comportamento-gastador",
      "title": "Comportamento gastador",
      "description": "O comportamento gastador pode trazer sérios prejuízos ao bolso. Para evitar esse tipo de situação, vale fazer um planejamento financeiro."
    },
    {
      "badge": "Economizando",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/analise-de-despesas",
      "title": "Análise de Despesas",
      "description": "A análise de despesas ajuda a esclarecer se o dinheiro está sendo utilizado de forma eficiente, evitando desperdícios e acúmulo de dívidas."
    },
    {"badge": "Economizando",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/planejamento-financeiro",
      "title": "Planejamento financeiro",
      "description": "Com um bom planejamento financeiro você pode organizar suas finanças, garantir uma estabilidade econômica e ainda, aprender a investir."
    },
    {
      "badge": "Consumo",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/praticas-abusivas-no-comercio",
      "title": "Práticas abusivas no comércio",
      "description": "São exemplos de práticas abusivas no comércio as taxas de desperdício, de consumação mínima e valor mínimo para pagamento no cartão."
    },
    {
      "badge": "Receitas",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/orcamento-domestico",
      "title": "Orçamento Doméstico",
      "description": "O orçamento doméstico é uma ferramenta muito útil para quem deseja controlar todos os ganhos e despesas e manter as finanças."
    },
    {
      "badge": "Despesas",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/despesas-variaveis",
      "title": "Despesas Variáveis",
      "description": "As despesas variáveis são uma das ferramentas indispensáveis para elaboração de um bom planejamento financeiro familiar ou organizacional."
    },
    {"badge": "Economizando",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/economia-no-supermercado",
      "title": "Economia no Supermercado",
      "description": "Economia no supermercado é uma das primeiras alternativas para redução de gastos. Também ajuda a conservar as contas em equilíbrio."
    },
    {
      "badge": "Receitas",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/orcamento",
      "title": "Orçamento",
      "description": "O orçamento refere-se a uma estimativa de ganhos e despesas em médio e longo prazos. É um instrumento importante para a educação financeira."
    },
    {
      "badge": "Despesas",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/despesas-fixas",
      "title": "Despesas fixas",
      "description": "As despesas fixas variam de acordo com o contexto. Elas podem ser a conta de luz, parcela do carro, aluguel ou o salário dos funcionários."
    },
    {
      "badge": "Despesas",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/despesas-eventuais",
      "title": "Despesas Eventuais",
      "description": "As despesas eventuais não têm hora marcada para chegar, então como estar preparado? É hora de colocar as despesas na ponta do lápis."
    },
    {
      "badge": "Despesas",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/reduzir-despesas",
      "title": "Reduzir despesas",
      "description": "Reduzir despesas nem sempre é fácil, mas se ao final do mês você tem dificuldade para cobrir os gastos, é hora de enxugar o orçamento."
    },
    {
      "badge": "Receitas",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/empreendedorismo",
      "title": "Empreendedorismo",
      "description": "De onde surgiu o termo empreendedorismo? Neste artigo você vai saber qual a origem do conceito e receber dicas para ser um bom empreendedor."
    },
    {
      "badge": "Consumo",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/codigo-de-defesa-do-consumidor-cdc",
      "title": "Código de Defesa do Consumidor (CDC)",
      "description": "O Código de Defesa do Consumidor (CDC) garante que seus direitos básicos sejam assegurados e o protege de práticas abusivas."
    },
    {
      "badge": "Cartões",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/vantagens-e-desvantagens-do-cartao-de-credito",
      "title": "Vantagens e desvantagens do cartão de crédito",
      "description": "As vantagens e desvantagens do cartão de crédito estão atreladas a um bom planejamento financeiro e controle no momento das compras."
    },
    {
      "badge": "Despesas",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/endividamento",
      "title": "Endividamento",
      "description": "O endividamento é o reflexo de um descontrole orçamentário, sendo ocasionado principalmente pela falta de planejamento financeiro e desemprego."
    },
    {
      "badge": "Receitas",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/receita-variavel",
      "title": "Receita Variável",
      "description": "A receita variável também é usada no mercado financeiro. É um tipo de investimento cujo o retorno é imprevisível, mas bastante lucrativo."
    },
    {
      "badge": "Receitas",
      "link": "https://www.educamaisbrasil.com.br/enem/educacao-financeira/receita-fixa",
      "title": "Receita Fixa",
      "description": "A receita fixa também pode ser um tipo de investimento em que é possível prever sua rentabilidade, ou seja, seu retorno é garantido."
    }
  ]
  
  